import { Col, Form, Input, Modal, Row, Select, Switch } from "antd";
import toast from "react-hot-toast";
import { CreateUserDto } from "../../entities/dto/user.dto";
import { User } from "../../entities/interfaces/users";
import UserService from "../../services/users.service";

type Props = {
  open: boolean;
  selected?: User;
  onChange: () => void;
  onClose: () => void;
};

const ManageUser = ({ open, onChange, selected, onClose }: Props) => {
  const [form] = Form.useForm<CreateUserDto>();
  const isCreate = !selected;
  const title = isCreate ? "Create User" : "Update User";
  const okButtonText = isCreate ? "Create" : "Update";
  if (!isCreate) {
    form.setFieldsValue(selected);
  }

  const handleSubmit = async (values: CreateUserDto) => {
    const res = isCreate
      ? await UserService.create(values)
      : await UserService.update(selected.id, values);

    if (res?.success) {
      isCreate ? toast.success("User created") : toast.success("User updated");
      onChange();
      closeModal();
    }
  };

  const closeModal = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={title}
      open={open}
      onOk={form.submit}
      onCancel={closeModal}
      centered
      okText={okButtonText}
    >
      <Form
        name="basic"
        form={form}
        initialValues={{ remember: true }}
        onFinish={handleSubmit}
        autoComplete="off"
        layout="vertical"
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input name!" }]}
        >
          <Input autoComplete="off" />
        </Form.Item>
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: "Please input username!" }]}
        >
          <Input autoComplete="off" />
        </Form.Item>

        {isCreate && (
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please input password!" }]}
          >
            <Input.Password autoComplete="off" />
          </Form.Item>
        )}
        <Row gutter={20}>
          <Col flex="1">
            <Form.Item
              label="Role"
              name="role"
              rules={[{ required: true, message: "Please input role!" }]}
            >
              <Select>
                <Select.Option value="ADMIN">Admin</Select.Option>
                <Select.Option value="MANAGER">Manager</Select.Option>
                <Select.Option value="STAFF">Staff</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          {!isCreate && (
            <Col flex="1">
              <Form.Item label="Active" name="active">
                <Switch />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export default ManageUser;
